import i18n from "i18n";
import Select from "react-select";
import { useTranslation } from "react-i18next";


const DropdownHours = ({
    name="hours",
    initialValue,
    onChangeSelect,
    placeholder = "Time"
}: {
    name?: string
    initialValue?: string,
    onChangeSelect?: any,
    placeholder?: string
}) => {
    const { t } = useTranslation();

  const generateTimeSlots = () => {
    const times = [];
    let hour = 0;
    let minute = 0;
    
    for (let i = 0; i < 48; i++) {
      const hourFormatted = hour.toString().padStart(2, '0');
      const minuteFormatted = minute.toString().padStart(2, '0');
      times.push(`${hourFormatted}:${minuteFormatted}`);
      
      minute += 30;
      if (minute === 60) {
        minute = 0;
        hour += 1;
      }
    }
    const formatHourOption = times?.map((item) => (
        {
            label: item,
            value: item
        }
    ))
    return formatHourOption;
  };

  const timeSlots = generateTimeSlots();

  return (
    <div className="position-relative w-100">
        <Select
            options={timeSlots}
            value={timeSlots.find((item: any) => item.value === initialValue) || null}
            name={name}
            isDisabled={false}
            onChange={(e: any) => onChangeSelect && onChangeSelect(e)}
            placeholder={<div>{t(placeholder)}</div>}
            loadingMessage={() => (<div>{t('Loading')}...</div>)}
            noOptionsMessage={() => (<div>{t('No Options')}</div>)}
            cclassName="dropdown-status-rounded"
            classNamePrefix="name-prefix"
            isClearable={true}
            style={{
                maxWidth: '120px'
            }}
        />
    </div>
  );
};

export default DropdownHours;